module.exports = __webpack_public_path__ + "static/media/AR.fb6cf53e.png";